import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteMeetingPayload } from '@app-store/slices/meetings/deleteMeeting'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IDeleteMeetingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.delete

function* deleteMeetingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/meeting/${payload.meetingId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(rootActions.meetingAgenda.list.onUpdateList(response.result))
            notification.success({
                message: 'Meeting deleted successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteMeetingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteMeetingSagaTask)
}

export default deleteMeetingSaga
